//In view animation script

//Reduce the number of times the browser counts scroll events
var didScroll = false;
window.onscroll = setscroll;
window.onresize = setscroll;

function check_if_in_view() {
  var window_height = window.screen.height;
  var window_third = window_height/3;
  var window_top_position = window.pageYOffset | document.body.scrollTop;
  var window_bottom_position = (window_top_position + window_height);

  var animation_elements = document.querySelectorAll('.animation-element');

  for(let element of animation_elements) {
    var element_height = element.offsetHeight;
    var element_top_position = element.offsetTop;
    var element_bottom_position = (element_top_position + element_height);

    //check to see if this current container is within viewport
    if ((element_bottom_position - window_third >= window_top_position) &&
        (element_top_position + window_third <= window_bottom_position)) {
        element.classList.add('in-view');
    }
  }
}

function setscroll() {
	didScroll = true;
}

setInterval(function() {
    if(didScroll) {
        didScroll = false;
        check_if_in_view();
        user_scrolled();
    }
}, 200);

//Set up scroll events for "scrolled"	
function user_scrolled() {
	var window_top_position = window.pageYOffset | document.body.scrollTop;
  
	if(window_top_position > '50'){
		document.body.classList.add('user-scrolled');
    }
    if(window_top_position < '50'){
        document.body.classList.remove('user-scrolled');;
  	}
}